






















































































import moment from "moment/moment";
import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
import { Prop, Watch } from "vue-property-decorator";
import DateType from "@/shared/DateType";

@Component
export default class MyTimeChooser extends mixins(MyMixin) {
  @Prop({ default: new DateType() }) public dateType!: DateType;

  public showStartTime: boolean = false;
  public showEndTime = false;
  public startTime: string = "00:00";
  public endTime: string = "00:00";

  // mounted
  public mounted() {
    console.log("bonjour le time");
    this.initTimes();
  }

  public updateTime() {
    this.showEndTime = false;
    this.showStartTime = false;
    this.myTime.heureDebut = this.startTime;
    this.myTime.heureFin = this.endTime;
    this.update();
  }

  @Watch("dateType", { immediate: true, deep: true })
  public onPropertyChanged(value: any, oldValue: any) {
    if (oldValue !== undefined) {
      this.initTimes();
    }
  }
  private initTimes() {
    this.startTime = this.myTime.heureDebut;
    this.endTime = this.myTime.heureFin;
  }

  private update() {
    this.$emit("updateTime", this.myTime);
  }

  get myTime() {
    return this.dateType;
  }
}
